import styled from 'styled-components';

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px 40px 40px;

  > button {
    min-width: auto;
  }
`;

export const LoaderWrapper = styled.div`
  margin-bottom: 16px;
`;

export const DescriptionDisclaimer = styled.p`
  font-style: italic;
  padding: 0 40px;
  margin-bottom: 20px;
`;
